import { render, staticRenderFns } from "./ToggleButtons.vue?vue&type=template&id=5d4a924a"
import script from "./ToggleButtons.vue?vue&type=script&lang=js"
export * from "./ToggleButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports